<template>
  <div class="breadcrumbs d-block d-md-flex justify-content-between">
    <p>
      <span v-for="(breadCrumb, index) in breadCrumbs" :key="breadCrumb.index">
        <a :href="breadCrumb.path">{{ breadCrumb.title }}</a>

        <span
          v-if="
            index < breadCrumbs.length - 1 ||
              (index < breadCrumbs.length && currentpage)
          "
          class="seperator"
        >
          &nbsp;
          <font-awesome-icon icon="chevron-right" />
        </span>
      </span>
      <span class="currentpage">{{ currentpage }}</span>
    </p>
    <div>
      Terug naar <a href="https://www.west-vlaanderen.be/vrije-tijd-en-toerisme/uitleendienst-van-de-provincie">West Vlaanderen</a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    breadCrumbs: {
      type: Array,
      required: false,
      default: function() {
        return [{ page: 'index', title: 'Uitleendienst', path: '/' }]
      }
    },

    currentpage: {
      type: String,
      default: function() {
        return null
      }
    }
  }
}
</script>
<style lang="scss" scoped>
p {
  font-size: 18px;
  font-family: 'DecimaPro';
}
.seperator {
  font-size: 14px;
  line-height: 20px;
  vertical-align: middle;
  padding-left: 6px;
  padding-right: 6px;
  color: #333333;
}
.currentpage {
  color: #070808;
}
</style>
